import ErrorFallbackWithReload from ".";

export default function ErrorFallbackWithReloadExamples() {
  return <ErrorFallbackWithReload />;
}
